import { LuRefreshCw } from 'react-icons/lu'
import { recurrencyCopy } from '../copy'

export const RecurrencyInfoBox = () => (
  <aside className="flex items-start gap-3 rounded-xl bg-gray-100 p-4 text-sm text-gray-700">
    <LuRefreshCw aria-hidden="true" className="mt-0.5 h-5 w-5 shrink-0 text-gray-800" />
    <p>
      <strong className="font-semibold text-gray-900">{recurrencyCopy.infoBox.title}</strong>{' '}
      {recurrencyCopy.infoBox.body}
    </p>
  </aside>
)
